<template>
  <section class="scene-box">
     <h6>视频接待</h6>
     <div>浏览器打开kf.sdo.com,</div>
     <div>选择人工服务-视频接待</div>
     <h6>现场接待:</h6>
    
     
     <router-link  class="my-order" tag="a" :to="{path: '/orderForm'}" @click.native="countNumber(4,8)">我要预约</router-link>
  </section>
 
  </section>
  
  

</template>

<script>

export default {
  components: {
  },
   
  name: 'scene',
  created: function () {
    
  },
  data () {
    return {
     
    }
  },
  methods:{
    
  }
}
</script>


<style scoped>
.scene-box{}
.scene-box h6{height: 0.63rem;font-size: 0.32rem;background: url(../../assets/qq-ico.png) no-repeat 0.74rem center; text-indent: 0.7rem;background-size: 0.42rem 0.47rem;line-height: 0.63rem;font-weight: normal;padding-left: 0.74rem}
.scene-box h6:nth-of-type(2){margin-top: 0.30rem;border-top: 1px solid #999;padding-top: 0.4rem;background-position: 0.74rem 0.45rem}
.scene-box div{font-size: 0.24rem;color: #999;line-height: 0.54rem;height: 0.54rem;margin-left: 0.74rem}
.scene-box div:nth-of-type(1){margin-top: 0.2rem}
.my-order{width: 5rem;height: 0.64rem;line-height: 0.64rem;text-align: center;color: #e5004f;border: 1px solid #e5004f;display: block;font-size: 0.3rem;margin-top: 0.7rem;margin-left:1.24rem}
</style>



// WEBPACK FOOTER //
// src/components/base/scene.vue